import { useState, RefObject, useCallback } from 'react';

export function useStateRef() {
  const [element, setElement] = useState<any>(null);
  const ref = useCallback((el: RefObject<any>) => {
    setElement(el);
  }, []);
  return [element, ref];
}
